import { render, staticRenderFns } from "./admin-schools.vue?vue&type=template&id=5a5cddfc&scoped=true"
import script from "./admin-schools.vue?vue&type=script&lang=js"
export * from "./admin-schools.vue?vue&type=script&lang=js"
import style0 from "./admin-schools.vue?vue&type=style&index=0&id=5a5cddfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5cddfc",
  null
  
)

export default component.exports